import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Table, Container, Row, Col } from "reactstrap";
import { getDailySubscriptionOrdersHistory } from "./_requests";

const UserPlanSubscriptionHistory = () => {
  const { id } = useParams();
  const [orderHistory, setOrderHistory] = useState<
    Array<{
      month: string;
      deliveries: Array<{
        day: string;
        date: string;
        status: string;
      }>;
    }>
  >([]);

  useEffect(() => {
    if (id) {
      getDailySubscriptionOrdersHistory({ user_subscription_orders_id: id }).then((res) => {
        setOrderHistory(res.data);
      });
    }
  }, [id]);

  return (
    <div>
      <Container fluid>
        <Row>
          <Col lg={12}>
            <Table bordered responsive>
              <thead className="text-primary fw-bold">
                <tr>
                  <th>#</th>
                  <th>Month</th>
                  <th>Day</th>
                  <th>Date & Time</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {orderHistory?.length > 0 ? (
                  orderHistory.map((item, index) => (
                    item.deliveries.map((delivery, dIndex) => (
                      <tr key={`${index}-${dIndex}`}>
                        <td>{index + 1}</td>
                        <td>{item.month}</td>
                        <td>{delivery.day}</td>
                        <td>{delivery.date}</td>
                        <td>{delivery.status}</td>
                      </tr>
                    ))
                  ))
                ) : (
                  <tr>
                    <td colSpan={5} className="text-center fw-bold">
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default UserPlanSubscriptionHistory;
